import { render } from "./our-product.vue?vue&type=template&id=5d451764&scoped=true"
import script from "./our-product.vue?vue&type=script&lang=js"
export * from "./our-product.vue?vue&type=script&lang=js"

import "./our-product.vue?vue&type=style&index=0&id=5d451764&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d451764"]])

export default __exports__